import { Icon } from './Layout'
import { usePlatformSettings } from '../context/PlatformSettingsContext'

const CHECKLIST = [
  'Email verification',
  'Wallet connection',
  'Profile completion',
  '3 posts created',
  '5 comments made',
  '7-day check-in streak',
]

export default function ReferralRewardsModal({ onClose }) {
  const { referralRewards } = usePlatformSettings()
  const r = referralRewards ?? {}
  const fmt = (n) => Number(n ?? 0).toLocaleString()

  return (
    /* Backdrop */
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-md bg-surface-container border-2 border-on-background neo-shadow max-h-[90vh] overflow-y-auto"
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 lg:p-6 border-b border-on-background/10 sticky top-0 bg-surface-container">
          <h2 className="font-extrabold uppercase tracking-tight text-[16px] lg:text-[20px] flex items-center gap-2">
            <Icon name="group_add" className="text-primary-container text-[20px] lg:text-[24px]" />
            How Referral Rewards Work
          </h2>
          <button
            onClick={onClose}
            className="text-on-surface-variant hover:text-on-background"
          >
            <Icon name="close" className="text-[20px]" />
          </button>
        </div>

        <div className="p-4 lg:p-6 flex flex-col gap-5 lg:gap-6">
          {/* Step 1 — signup bonus */}
          <div>
            <p className="text-[10px] lg:text-[11px] uppercase font-bold text-on-surface-variant tracking-widest mb-2">
              1 · On sign-up
            </p>
            <div className="grid grid-cols-2 gap-2">
              <div className="border border-on-background/15 bg-background p-3">
                <p className="text-[10px] uppercase font-bold text-on-surface-variant mb-1">New user</p>
                <p className="text-lg lg:text-xl font-extrabold text-primary-container">+{fmt(r.signupReferredCis)} CIS</p>
              </div>
              <div className="border border-on-background/15 bg-background p-3">
                <p className="text-[10px] uppercase font-bold text-on-surface-variant mb-1">Referrer</p>
                <p className="text-lg lg:text-xl font-extrabold text-primary-container">+{fmt(r.signupReferrerCis)} CIS</p>
              </div>
            </div>
          </div>

          {/* Step 2 — activation checklist */}
          <div>
            <p className="text-[10px] lg:text-[11px] uppercase font-bold text-on-surface-variant tracking-widest mb-2">
              2 · New user completes
            </p>
            <ul className="flex flex-col gap-1.5">
              {CHECKLIST.map((item) => (
                <li key={item} className="flex items-center gap-2 text-sm text-on-background">
                  <Icon name="check_circle" filled className="text-primary-container text-[16px] shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Step 3 — completion bonus */}
          <div>
            <p className="text-[10px] lg:text-[11px] uppercase font-bold text-on-surface-variant tracking-widest mb-2">
              3 · After completion
            </p>
            <div className="grid grid-cols-2 gap-2">
              <div className="border border-on-background/15 bg-background p-3">
                <p className="text-[10px] uppercase font-bold text-on-surface-variant mb-1">New user</p>
                <p className="text-lg lg:text-xl font-extrabold text-primary-container">+{fmt(r.completionReferredCis)} CIS</p>
              </div>
              <div className="border border-on-background/15 bg-background p-3">
                <p className="text-[10px] uppercase font-bold text-on-surface-variant mb-1">Referrer</p>
                <p className="text-lg lg:text-xl font-extrabold text-primary-container">+{fmt(r.completionReferrerCis)} CIS</p>
              </div>
            </div>
          </div>

          {/* Step 4 — staking milestone */}
          <div className="bg-on-background text-surface p-3 lg:p-4 flex items-center justify-between gap-3">
            <div>
              <p className="text-[10px] uppercase font-bold text-surface/60 mb-0.5">4 · First staking milestone</p>
              <p className="text-sm font-bold">Paid to the referrer</p>
            </div>
            <p className="text-xl lg:text-2xl font-extrabold text-primary-container shrink-0">+{fmt(r.stakingReferrerCis)} CIS</p>
          </div>

          <button
            onClick={onClose}
            className="w-full py-3 bg-primary-container text-on-primary-fixed font-bold uppercase text-sm border border-on-background neo-shadow-sm active:scale-95 transition-all"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  )
}